import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContractWidget } from '@models/contract-widgets';
import { Contract } from '@models/contract';
import { PortalCollapsibleComponent, PortalWidgetDetailsComponent } from '../../components';
import { Insurant } from '@models/insurant';
import { InsurantFullNamePipe } from '../../../shared/pipes/insurant-full-name.pipe';

@Component({
    selector: 'app-single-insurant-widget',
    imports: [PortalCollapsibleComponent, PortalWidgetDetailsComponent, InsurantFullNamePipe],
    templateUrl: './single-insurant-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleInsurantWidgetComponent implements ContractWidget {
    @Input({ required: true })
    public contract: Contract;

    public get insurant(): Insurant {
        return this.contract.insurants[0];
    }
}
